import { useState, useCallback, useEffect } from 'react';
import groupServices from 'services/group.services';

export default function useGetGroupChargeType() {
  const [loading, setLoading] = useState(false);
  const [listChargeTypes, setListChargeTypes] = useState([]);

  const getChargeTypes = useCallback(async () => {
    try {
      setLoading(true);
      const data = await groupServices.listGroupChargeType();
      setListChargeTypes(data.items);
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getChargeTypes();
  }, []);

  return {
    loading,
    listChargeTypes,
    getChargeTypes
  };
}
